import { Quote, Users } from "lucide-react";
import { numerosImpacto, testemunhos } from "@/content/instituto";
import CountUp from "./CountUp";

// Extrai número puro da string "+3.487" → 3487, mantém fallback pro original
function parseNumber(v) {
  if (typeof v !== "string") return null;
  const digits = v.replace(/[^\d]/g, "");
  if (!digits) return null;
  return parseInt(digits, 10);
}

export default function ProvaSocial() {
  return (
    <section
      id="prova-social"
      data-testid="prova-social-section"
      className="section-pad bg-background"
    >
      <div className="container-ga">
        <div className="pill border-ga-ink/10 text-ga-ink/60 bg-ga-ink/5 mb-6" data-testid="prova-social-pill">
          <Users className="w-3.5 h-3.5" />
          Prova social
        </div>
        <h2 className="font-display font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-ga-ink max-w-3xl">
          Vidas que foram transformadas, em <span className="gradient-text-ga">primeira pessoa</span>.
        </h2>

        {/* Números */}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          {numerosImpacto.map((n) => {
            const num = parseNumber(n.v);
            const prefix = n.v.startsWith("+") ? "+" : "";
            return (
              <div
                key={n.k}
                data-testid={`numero-${n.k.replace(/\s/g, "-").toLowerCase().slice(0, 40)}`}
                className="rounded-3xl bg-white border border-border p-6"
              >
                <div className="font-display font-black text-4xl text-ga-ink tabular-nums">
                  {num !== null ? (
                    <>{prefix}<CountUp to={num} duration={1600} /></>
                  ) : (
                    n.v
                  )}
                </div>
                <div className="text-sm text-ga-ink/60 mt-2 leading-snug">{n.k}</div>
              </div>
            );
          })}
        </div>

        {/* Testemunhos */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {testemunhos.map((t, i) => (
            <figure
              key={t.nome}
              data-testid={`testemunho-${i}`}
              className="relative rounded-3xl bg-white border border-border p-6 flex flex-col"
            >
              <Quote className="absolute top-5 right-5 w-8 h-8 text-ga-amber/40" />
              <blockquote className="text-ga-ink leading-relaxed text-[15px] flex-1">
                {t.texto}
              </blockquote>
              <figcaption className="mt-5 pt-5 border-t border-border flex items-center gap-3">
                {t.avatar ? (
                  <img
                    src={t.avatar}
                    alt={t.nome}
                    loading="lazy"
                    className="w-11 h-11 rounded-full object-cover ring-2 ring-ga-amber/30"
                  />
                ) : (
                  <div className="w-11 h-11 rounded-full bg-ga-emerald/10 text-ga-emerald_deep flex items-center justify-center font-display font-bold text-sm">
                    {t.nome
                      .split(" ")
                      .map((n) => n[0])
                      .slice(0, 2)
                      .join("")}
                  </div>
                )}
                <div className="min-w-0">
                  <div className="font-bold text-ga-ink truncate">{t.nome}</div>
                  <div className="text-xs text-ga-ink/60 truncate">{t.papel}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
